import { render, staticRenderFns } from "./MobileCommunityUnitBusinessNewsCreate.vue?vue&type=template&id=0fd27266&"
import script from "./MobileCommunityUnitBusinessNewsCreate.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityUnitBusinessNewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityUnitBusinessNewsCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports